export default __webpack_public_path__ + "static/media/online-learning.a3dc8b87.png";